import { Api } from 'models/services/api';
import { ReadIngredientItemsQuery } from 'models/services/graphql';

import { IngredientItemCollectionData } from '../collection';

type DataToFetch = {
  businessId: string;
  nextToken?: string;
};

const RequestQuery = `
  query ReadIngredientItems($businessId: ID!, $nextToken: String) {
    ${ReadIngredientItemsQuery}
  }
`;

type ResponseData = {
  data: {
    readIngredientItems: IngredientItemCollectionData;
  }
}

class ReadCollectionGql {

  readonly result?: IngredientItemCollectionData;
  private readonly api: Api<ResponseData>;

  constructor() {
    this.api = new Api<ResponseData>(RequestQuery);
  }

  async fetch(data: DataToFetch): Promise<this> {
    const api = await this.api.fetch({ variables: data });
    if (!api.response) throw new Error('invalid response');
    const result = api.response.data.readIngredientItems;
    return Object.assign(Object.create(this.constructor.prototype), { ...this, result, api });
  }

}

export { ReadCollectionGql };
export type { DataToFetch as ReadCollectionGqlDataToFetch }
